import { config } from './../../../config';
import { Injectable } from "@angular/core";

@Injectable()
export class ApiGatewayHelperService {
    constructor() { }

    getApiGatewayPrefixUrl()  {
        return config.apiGatewayUrl;
    }
}
